import DOMPurify from "dompurify";
import type { TokenProvider } from "#lib/tokenProvider.js";

export function tokenizePlainText(tokenProvider: TokenProvider, text: string | undefined): string {
	if (!text) {
		return "";
	} else if (!tokenProvider.hasSubstitutionToken(text)) {
		return text;
	}
	return tokenProvider
		.parse(text)
		.map(token => {
			if (!tokenProvider.instanceofSubstitutionToken(token)) return token.value;
			const value = DOMPurify.sanitize(token.value).replaceAll('"', "&quot;");
			const label = DOMPurify.sanitize(token.label).replaceAll('"', "&quot;");
			const provider = DOMPurify.sanitize(token.provider).replaceAll('"', "&quot;");
			return `<span data-type="data-token" data-label="${label}" data-value="${value}" data-provider="${provider}">${value}</span>`;
		})
		.join("");
}
